import React from "react";
import {
  MapPin,
  Calendar,
  Ruler,
  Building2,
  User,
  FileText,
  Eye,
} from "lucide-react";
import { Card } from "../../components/AdminSharedComponents";
import StatusBadge from "./StatusBadge";

const ExcavationCard = ({ excavation, onSelect, isSelected }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "Not set";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <Card
      className={`!p-4 cursor-pointer transition-all hover:shadow-md hover:ring-2 hover:ring-primary/20 ${
        isSelected ? "ring-2 ring-primary/40" : ""
      }`}
      onClick={() => onSelect(excavation)}
    >
      {/* Header */}
      <div className="flex items-start justify-between gap-2 mb-2">
        <h3 className="font-semibold text-base text-gray-900 line-clamp-1 flex-1 min-w-0">
          {excavation.name || "Unnamed Excavation"}
        </h3>
        <StatusBadge status={excavation.status || "Unknown"} />
      </div>

      {/* Info list */}
      <div className="space-y-2 text-sm text-gray-600">
        {excavation.Project && (
          <div className="flex items-center gap-2">
            <Building2 className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>{excavation.Project.name}</span>
          </div>
        )}

        {excavation.depth && (
          <div className="flex items-center gap-2">
            <Ruler className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>Depth: {excavation.depth} m</span>
          </div>
        )}

        {excavation.contractor && (
          <div className="flex items-center gap-2">
            <User className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>{excavation.contractor}</span>
          </div>
        )}

        {excavation.start_date && (
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>Start: {formatDate(excavation.start_date)}</span>
          </div>
        )}

        {excavation.end_date && (
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>End: {formatDate(excavation.end_date)}</span>
          </div>
        )}

        {excavation.coordinates && (
          <div className="flex items-center gap-2">
            <MapPin className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>Location mapped</span>
          </div>
        )}
      </div>

      {/* Progress */}
      {excavation.progress !== undefined && excavation.progress !== null && (
        <div className="mt-4">
          <div className="flex justify-between items-center mb-1">
            <span className="text-xs text-gray-500">Progress</span>
            <span className="text-xs font-medium text-gray-700">
              {excavation.progress}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-blue-500 h-2 rounded-full transition-all duration-300"
              style={{ width: `${excavation.progress}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Footer */}
      <div className="flex items-center justify-between mt-4 pt-2 border-t border-gray-100">
        <span className="text-xs text-gray-500">
          {formatDate(excavation.created_at)}
        </span>
        <div className="text-sm text-primary hover:text-primary-dark transition-colors flex items-center gap-1">
          <Eye className="h-4 w-4" />
          View
        </div>
      </div>
    </Card>
  );
};

export default ExcavationCard;
